import { MIME_TYPE } from "../../constants";
import { isValidMimeType } from "../isValidMimeType";

export const formatFileType = (mimeType: string): string => {
  return isValidMimeType(mimeType) ? MIME_TYPE[mimeType] : "unknown";
};
